let tokenGetter = null;

export const setTokenGetter = (fn) => {
  tokenGetter = fn;
};

export const getTokenGetter = () => tokenGetter;
